export default [
  ['=', '+', '%', '*', '[', ']', '{', '}', '<', '>'],
  ['@', ':', ';', '_', '-', '#', '(', ')', '/', '\\'],
  ['.', ',', '?', '!', "'", '"', '^']
];
